import { Component, ComponentRef, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogComponent } from '../../dialog/dialog.component';

@Component({
  selector: 'app-modal-default',
  templateUrl: './modal-default.component.html',
  styleUrls: ['./modal-default.component.scss']
})
export class ModalDefaultComponent implements OnInit {

  @ViewChild('target', { read: ViewContainerRef, static: true })
  vcRef!: ViewContainerRef;
  componentRef!: ComponentRef<any>;
  opened: boolean = true;
  disabled: boolean = false;
  
  dialogContext: any;

  onSaveEvent = (componentInstance: any) => {
    return Promise.resolve(true);
  };

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(this.data);
    this.dialogContext = this; // Asignar el contexto del componente de diálogo a la variable dialogContext
  }


  onOkClick(): void {
    console.log('onOkClick');
    this.onSaveEvent.call(this, this.getComponentInstance()).then((result) => {
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }

  ngOnInit() {
    if(this.data.component != undefined) this.componentRef = this.vcRef.createComponent(this.data.component)
    if(this.data.disabled != undefined) this.disabled = this.data.disabled;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public getComponentInstance() {
    if (this.componentRef)
      return this.componentRef.instance;
    else
      return undefined;
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}